import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal } from "@air/primitive-modal";
import { memo } from "react";
import { AnonymousSignUpOverlay } from "~/components/PublicLinkAnonymousSignUpModal/AnonymousSignUpOverlay";
export const AnonymousSignUpModal = /*#__PURE__*/ memo((param)=>{
    let { "data-testid": testId, children, isOpen } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AnonymousSignUpOverlay, {}),
            /*#__PURE__*/ _jsx(Modal, {
                "data-testid": testId,
                overlayClassName: "bg-transparent",
                isOpen: isOpen,
                className: "p-0",
                children: children
            })
        ]
    });
});
AnonymousSignUpModal.displayName = "AnonymousSignUpModal";
